<template>
  <div class="s-dealmakers-container">
    <topNav></topNav>
    <div class="s-dealmakers-top">
      <div class="banner w1300 marginAuto"></div>
    </div>

    <div class="s-dealmakers-body">
      <div class="conditions w1300 marginAuto mt10">
        <el-row class="conditions-row">
          <div class="conditions-row-1">
            <div class="conditions-colName">产品类型</div>
            <div class="conditions-colContent">
              <span
                v-for="(itm,ind) in matchUpClass"
                :key="ind"
                class="col-span"
                :class="ind ==active1?'active':''"
                @click="checkmatch(1,ind,itm,'产品类型')"
              >{{ itm }}</span>
            </div>
          </div>

          <div class="conditions-row-1">
            <div class="conditions-colName">交易类型</div>
            <div class="conditions-colContent conditions-colContent-last">
              <span
                v-for="(itm,ind) in transactionList"
                :key="ind"
                class="col-span"
                :class="ind ==active4?'active':''"
                @click="checkmatch(4,ind,itm,'交易类型')"
              >{{ itm }}</span>
            </div>
          </div>
        </el-row>
      </div>
      <div class="w1300 marginAuto queryDiv">
        <div class="query">
          <el-input v-model="queryKey" placeholder="请输入关键词搜索" class="search_input">
            <!-- @keyup.enter.native="getListByPageInfo" -->
            <template v-slot:suffix>
              <div @click="handlematchUpQuery">
                <i class="el-input__icon el-icon-search"></i>
              </div>
              <!-- @click="getListByPageInfo" -->
            </template>
          </el-input>
          <div class="issue" @click="handleSetRelease">我要发布</div>
        </div>
      </div>
      <div class="w1300 marginAuto s-transaction-wrap" v-if="setReleaseData.length > 0">
        <div
          class="s-transaction-item"
          v-for="(item,index) in setReleaseData"
          :key="index"
          @click="godetailMatchUp(item)"
        >
          <div class="stateBox" v-if="item.promotion == 1">
            <!-- <span v-if="item.dataStatus == '0'">正常</span>
            <span v-if="item.dataStatus == '1'">已关闭</span>
            <span v-if="item.dataStatus == '2'">已完成</span>
            <span v-if="item.dataStatus == '3'">求购</span>
            <span v-if="item.dataStatus == '4'">供应</span>
            <span v-if="item.dataStatus == '5'">撮合</span>-->
            <img src="../assets/image/dealmakers/tuiguang.png" alt />
          </div>
          <div class="s-transaction-img">
            <!-- <img :src="imgUrlRelease==null?defaultImg:imgURL+'/'+imgUrlRelease" alt /> -->
            <img :src="item.img==null?defaultImg:item.img" alt />
          </div>
          <!-- <div class="s-transaction-info">
            <div class="s-transaction-info-title">{{ item.transactionTitle }}</div>
            <div
              class="s-transaction-info-address"
            >{{ item.proninceValue }}{{ item.cityValue }}{{ item.countyValue }}{{ item.address }}</div>
            <div class="s-transaction-info-bottom">
              <div class="s-transaction-info-name">{{ item.contacts }}</div>
              <div class="s-transaction-info-date">{{ item.transactionDate }}</div>
            </div>
          </div>-->
          <div class="s-transaction-info">
            <div class="s-transaction-info-title">{{item.transactionTitle}}</div>
            <div class="s-transaction-info-type">
              <span
                class="bg-type"
                :class="item.transactionType !=null && item.transactionType !='' && item.transactionType == '求购'? 'bg-green':
                item.transactionType !=null && item.transactionType !='' && item.transactionType == '供应'?'bg-yellow':''"
              >{{item.transactionType || '--'}}</span>
              <span class="bg-red">{{item.transactionNumber || '--'}}{{item.numberUnit}}</span>
              <span
              class="bg-type"
              v-show="item.dataStatus !=0"
                :class="item.dataStatus !=null && item.dataStatus !='' && item.dataStatus == '1'? 'bg-gray':
                item.dataStatus !=null && item.dataStatus !='' && item.dataStatus == '2'?'bg-blue':''"
              >{{item.dataStatus == 1?'已关闭':(item.dataStatus == 0?'正常':(item.dataStatus == 2?'已完成':'--'))}}</span>
            </div>
            <div class="s-transaction-info-price">
              <span class="price">￥{{item.transactionPrice || '--'}}</span>
              <span class="unit">{{item.priceUnit}}</span>
            </div>
            <div class="s-transaction-info-address">
              <i class="el-icon-location" style="font-size:20px;color:#AAA"></i>
              {{item.proninceValue}}{{item.cityValue}}{{item.countyValue}}{{item.address}}
            </div>
            <!-- <div class="s-transaction-info-bottom">
              <div class="s-transaction-info-name">{{item.contacts}}</div>
              <div class="s-transaction-info-date">{{item.transactionDate}}</div>
            </div>-->
          </div>
        </div>
        <div style="display:flex;justify-content:flex-end;width:100%">
          <el-pagination
            class="tab_pagination"
            background
            :pageSize="pageSize"
            layout="prev, pager, next"
            @current-change="currentChange"
            :total="total"
          ></el-pagination>
        </div>
      </div>
      <div class="w1300 marginAuto" v-else>
        <el-empty description="暂无数据！" :image="noDataImg" :image-size="400"></el-empty>
      </div>

      <div class="w1300 marginAuto enterprise-apply-wrap">
        <div class="title">福安茶叶品牌会员申请流程</div>
        <div
          class="text"
        >企业用户通过使用“福安茶叶品牌宣推公共服务平台”品牌会员，申请企业账号注册成功成为品牌会员。然后，提交企业信息、品牌授权信息进行备案，协会统一审核处理，企业会员即可使用福安茶叶品牌。</div>
        <div class="apply-button-wrap">
          <div class="apply-block">
            <img :src="require('@/assets/image/dealmakers/process1.png')" alt />
            <div>申请会员</div>
          </div>
          <img :src="require('@/assets/image/dealmakers/arrow.png')" class="arrow-image" />
          <div class="apply-block">
            <img :src="require('@/assets/image/dealmakers/process2.png')" alt />
            <div>选择会员类型</div>
          </div>
          <img :src="require('@/assets/image/dealmakers/arrow.png')" class="arrow-image" />
          <div class="apply-block">
            <img :src="require('@/assets/image/dealmakers/process3.png')" alt />
            <div>协会审核</div>
          </div>
          <img :src="require('@/assets/image/dealmakers/arrow.png')" class="arrow-image" />
          <div class="apply-block">
            <img :src="require('@/assets/image/dealmakers/process4.png')" alt />
            <div>会员申请成功</div>
          </div>
          <img :src="require('@/assets/image/dealmakers/arrow.png')" class="arrow-image" />
          <div class="apply-block">
            <img :src="require('@/assets/image/dealmakers/process5.png')" alt />
            <div>企业备案</div>
          </div>
          <img :src="require('@/assets/image/dealmakers/arrow.png')" class="arrow-image" />
          <div class="apply-block">
            <img :src="require('@/assets/image/dealmakers/process6.png')" alt />
            <div>协会审核</div>
          </div>
          <img :src="require('@/assets/image/dealmakers/arrow.png')" class="arrow-image" />
          <div class="apply-block">
            <img :src="require('@/assets/image/dealmakers/process6.png')" alt />
            <div>完成</div>
          </div>
        </div>
        <div class="enterprise-apply-button" @click="handleApply">
          <img :src="require('@/assets/image/dealmakers/apply.png')" class="apply-image" />
          <span>我要申请</span>
        </div>
      </div>
    </div>
    <footer-nav></footer-nav>

    <!-- 信息发布 -->
    <el-dialog
      :title="matchUpTitle"
      :visible.sync="setReleaseDialog"
      width="80%"
      :before-close="handleSetReleaseClose"
      class="transactionsReleaseDialog"
    >
      <div class="transactions-release-body">
        <el-form ref="matchForm" :model="matchUpForm" :rules="matchUpRules" label-width="100px">
          <el-form-item label="标题" class="transactions-form-item" prop="transactionTitle">
            <el-input v-model.trim="matchUpForm.transactionTitle" maxlength="20" clearable></el-input>
          </el-form-item>

          <el-form-item label="产品类型" class="transactions-form-item" prop="matchUpType">
            <el-select v-model="matchUpForm.matchUpType" clearable placeholder="请选择">
              <el-option
                v-for="item in matchUpTypeData"
                :key="item.codeName"
                :label="item.codeName"
                :value="item.codeName"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="地区" class="transactions-form-item transactions-form-regon" required>
            <el-col :span="8">
              <el-form-item prop="pronince">
                <el-select
                  v-model="matchUpForm.pronince"
                  clearable
                  placeholder="请选择"
                  @change="selectListRegion($event,'市')"
                >
                  <el-option
                    v-for="item in provinceData"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="city">
                <el-select
                  v-model="matchUpForm.city"
                  clearable
                  placeholder="请选择"
                  @change="selectListRegion($event,'县')"
                >
                  <el-option
                    v-for="item in cityData"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="county">
                <el-select v-model="matchUpForm.county" clearable placeholder="请选择">
                  <el-option
                    v-for="item in countyData"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item label="交易类型" class="transactions-form-item" prop="transactionType">
            <el-select v-model="matchUpForm.transactionType" clearable placeholder="请选择">
              <el-option
                v-for="item in transactionTypeData"
                :key="item.codeName"
                :label="item.codeName"
                :value="item.codeName"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="详细地址" class="transactions-form-item" prop="address">
            <el-input v-model.trim="matchUpForm.address" maxlength="20" clearable></el-input>
          </el-form-item>

          <el-form-item label="数量" class="transactions-form-item" prop="transactionNumber">
            <el-input
              v-model.trim="matchUpForm.transactionNumber"
              type="number"
              maxlength="10"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="发布人" class="transactions-form-item" prop="contacts">
            <el-input v-model.trim="matchUpForm.contacts" maxlength="6" clearable></el-input>
          </el-form-item>

          <el-form-item label="数量单位" class="transactions-form-item" prop="numberUnit">
            <el-select v-model="matchUpForm.numberUnit" clearable placeholder="请选择">
              <el-option
                v-for="item in matchUpNumberUnitData"
                :key="item.codeName"
                :label="item.codeName"
                :value="item.codeName"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="联系电话" class="transactions-form-item" prop="contactsPhone">
            <el-input v-model.trim="matchUpForm.contactsPhone" maxlength="11" clearable></el-input>
          </el-form-item>

          <el-form-item label="价格" class="transactions-form-item" prop="transactionPrice">
            <el-input v-model.trim="matchUpForm.transactionPrice" maxlength="10" clearable></el-input>
          </el-form-item>

          <el-form-item label="图片" class="transactions-form-item" prop="img">
            <el-upload
              class="avatar-uploader"
              ref="matchUpImg"
              action
              :multiple="true"
              :limit="6"
              list-type="picture-card"
              :on-exceed="uploadExceed"
              :on-change="handleMatchUpUpload"
              :auto-upload="false"
              :file-list="matchUpFileList"
            >
              <!-- :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"-->
              <!-- <img
                v-if="matchUpForm.img"
                :src="imgURL+'/'+matchUpForm.img"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-delete" @click="handleRemove2(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
          </el-form-item>

          <el-form-item label="价格单位" class="transactions-form-item" prop="priceUnit">
            <el-select v-model="matchUpForm.priceUnit" clearable placeholder="请选择">
              <el-option
                v-for="item in matchUpPriceUnitData"
                :key="item.codeName"
                :label="item.codeName"
                :value="item.codeName"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="日期" class="transactions-form-item form-right" prop="transactionDate">
            <el-date-picker
              v-model="matchUpForm.transactionDate"
              clearable
              type="datetime"
              placeholder="选择日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>

          <div style="clear:both"></div>
        </el-form>
        <div class="transactions-release-footer" v-if="matchUpTitle=='信息发布'">
          <div class="transactions-release-close" @click="handleSetReleaseClose">取消</div>
          <div class="transactions-release-sure" @click="submitMatchUpRelease('matchForm')">发布</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import topNav from "../components/topNav.vue";
import footerNav from "../components/footerNav.vue";
import validate from "../utils/js/validator"; //检验
import {
  selectListByType,
  getMatchUpListPage,
  selectListRegion,
  matchUpReleaseUploadImg,
  addMatchUp,
  transactionGetById,
  matchUpGetById,
  getMatchUpClassification,
  productTypeSelectList
} from "./../utils/api/dealmakers";

export default {
  name: "priceQuotation",
  components: { topNav, footerNav },
  data() {
    return {
      transactionTypeData: [], // 交易类型
      matchUpTypeData: [], // 产品类型
      matchUpFileList: [],
      active1: 0,
      active2: 0,
      active3: 0,
      active4: 0,
      type: 1,
      typeId: "",
      classifyId: "",
      // varietyId: "",
      currentPage: 1, // 页码
      pageSize: 9, // 每页显示数量
      total: 1, // 总数
      queryKey: "",
      setReleaseDialog: false, // 撮合发布
      matchUpTitle: "信息发布",
      matchUpForm: {
        transactionTitle: "", // 标题
        matchUpType: "", // 产品类型
        transactionType: "", // 交易类型
        address: "", // 详细地址
        transactionNumber: "", // 数量
        contacts: "", // 发布人
        numberUnit: "", // 数量单位
        contactsPhone: "", // 联系电话
        transactionPrice: "", // 价格
        priceUnit: "", //价格单位
        transactionDate: "", // 日期
        img: [], // 图片
        pronince: "",
        city: "",
        county: ""
      },
      matchUpNumberUnitData: [
        // 数量单位
        {
          codeName: "人"
        },
        {
          codeName: "台"
        },
        {
          codeName: "辆"
        },
        {
          codeName: "个"
        },
        {
          codeName: "袋"
        },
        {
          codeName: "吨"
        },
        {
          codeName: "斤"
        },
        {
          codeName: "公斤"
        }
      ],
      matchUpPriceUnitData: [
        {
          codeName: "元/人"
        },
        {
          codeName: "元/台"
        },
        {
          codeName: "元/辆"
        },
        {
          codeName: "元/吨"
        },
        {
          codeName: "元/公斤"
        }
      ],
      matchUpRules: {
        transactionTitle: [
          { required: true, message: "请输入标题", trigger: "blur" }
        ],
        matchUpType: [
          { required: true, message: "请选择产品类型", trigger: "change" }
        ],
        transactionType: [
          { required: true, message: "请选择交易类型", trigger: "change" }
        ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ],
        transactionNumber: [
          { required: true, message: "请输入数量", trigger: "blur" },
          {
            validator: validate.FormValidate.Form().priceProp,
            trigger: "blur"
          }
        ],
        contacts: [
          { required: true, message: "请输入发布人", trigger: "blur" },
          {
            validator: validate.FormValidate.Form().validateName,
            trigger: "blur"
          }
        ],
        numberUnit: [
          { required: true, message: "请选择单位", trigger: "change" }
        ],
        contactsPhone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            validator: validate.FormValidate.Form().validatePhone,
            trigger: "blur"
          }
        ],
        transactionPrice: [
          { required: true, message: "请输入价格", trigger: "blur" },
          {
            validator: validate.FormValidate.Form().priceProp,
            trigger: "blur"
          }
        ],
        priceUnit: [
          { required: true, message: "请选择单位", trigger: "change" }
        ],
        transactionDate: [
          { required: true, message: "请选择日期", trigger: "change" }
        ],
        pronince: [{ required: true, message: "请选择", trigger: "change" }],
        city: [{ required: true, message: "请选择", trigger: "change" }],
        county: [{ required: true, message: "请选择", trigger: "change" }],
        img: [{ required: true, message: "请选择图片", trigger: "change" }]
      },
      provinceData: [], // 省数据
      cityData: [], // 市数据
      countyData: [], // 区数据
      setReleaseData: [],
      imgUrlRelease: "", //撮合图片
      defaultImg: require("../assets/image/dealmakers/default.png"),
      matchUpClass: [],
      matchUpProduct: [],
      transactionList: [],
      matchUpClassName: "全部",
      matchUpProductName: "全部",
      matchUpInfo: {
        classifyId: 0,
        transactionType: "0",
        type: 1,
        typeId: 0
      },
      noDataImg:require('../assets/image/pest/no-data.jpg')
    };
  },
  mounted() {
    // 获取省
    this.selectListRegion(0, "省");
    this.selectListByType(); // 获取交易类型
  },
  methods: {
    handleApply() {
      window.open("http://39.105.176.120:28081/brand-qy-v3/", "_blank");
    },
    // 切换页码
    currentChange(val) {
      this.currentPage = val;
      this.getMatchUpListPage();
    },
    godetailMatchUp(item) {
      this.$router.push({ path: "matchUpDetails", query: { id: item.id } });
    },

    async matchUpGetById(id) {
      let res = await matchUpGetById({ id: id });
      if (res.data.code == 0) {
        let that = this;
        this.selectListRegion(res.data.data.pronince, "市");
        this.selectListRegion(res.data.data.city, "县");
        // setTimeout(function(){
        that.matchUpForm = res.data.data;
        // },2500)
      }
    },
    // 省市区联动
    async selectListRegion(pid, name) {
      let res = await selectListRegion({
        orderBy: { id: "asc" },
        pid
      });
      if (res.data.code == 0) {
        if (name == "省") {
          this.provinceData = res.data.data;
          this.selectListRegion(this.provinceData[0].id, "市");
        }
        if (name == "市") {
          this.cityData = res.data.data;
          if (this.setReleaseDialog) {
            if (this.matchUpForm.city != "") {
              this.selectListRegion(this.matchUpForm.city, "县");
            } else {
              this.selectListRegion(this.cityData[0].id, "县");
            }
            if (this.matchUpTitle == "信息发布") {
              this.matchUpForm.city = "";
              this.matchUpForm.county = "";
            }
            // this.matchUpForm.city = "";
            // this.matchUpForm.county = "";
          }
        }
        if (name == "县") {
          if (this.setReleaseDialog) {
            if (this.matchUpTitle == "信息发布") {
              this.matchUpForm.county = "";
            }
          }
          this.countyData = res.data.data;
        }
      }
    },

    // 获取产品类型和交易类型
    async selectListByType() {
      let res1 = await selectListByType({
        codeType: "match_up_type"
      });
      let res2 = await selectListByType({
        codeType: "transaction_type"
      });
      if (res1.data.code === 0 && res2.data.code === 0) {
        this.matchUpTypeData = res1.data.data; //产品类型
        // this.matchUpForm.matchUpType = this.matchUpTypeData[0].codeName;
        this.transactionTypeData = res2.data.data; //交易类型
        // this.matchUpForm.transactionType = this.transactionTypeData[0].codeName;
        this.getMatchUpListPage();
        this.getMatchUpClassification(
          this.matchUpClassName,
          this.matchUpProductName
        );
      }
    },

    async getMatchUpClassification(matchUpName, matchUpType) {
      let params = {
        matchUpName,
        matchUpType
      };
      let res = await getMatchUpClassification(params);
      if ([200, 0].includes(res.data.code)) {
        this.transactionList = ["全部"];
        this.matchUpClass = res.data.data.matchUpClass;
        this.matchUpProduct = res.data.data.matchUpProduct;
        this.matchUpVarieties = res.data.data.matchUpVarieties;
        this.transactionList = this.transactionList.concat(
          res.data.data.transactionList
        );
      }
    },

    // 撮合信息切换撮合类型
    checkmatch(type, val, typeName, name) {
      this.currentPage = 1;
      if (type == 1) {
        this.active1 = val;
        this.matchUpClassName = typeName;
        this.matchUpInfo.type = 1;
        if (typeName == "全部") {
          this.matchUpInfo.typeId = 0;
        } else {
          this.matchUpInfo.typeId = typeName;
        }
        this.active2 = 0;
        this.active3 = 0;
        this.matchUpInfo.classifyId = 0;
        this.getMatchUpClassification("全部", this.matchUpClassName);
      } else if (type == 4) {
        if (typeName == "全部") {
          this.matchUpInfo.transactionType = 0;
        } else {
          this.matchUpInfo.transactionType = typeName;
        }
        this.active4 = val;
      }
      this.matchUpForm.matchUpType = typeName;
      this.getMatchUpListPage();
    },

    // 撮合类型分页
    async getMatchUpListPage() {
      let pramas = {
        currentPage: this.currentPage, // 页码
        pageSize: this.pageSize, // 每页显示数量
        queryKey: this.queryKey ? this.queryKey : undefined,
        type: this.matchUpInfo.type,
        classifyId: this.matchUpInfo.classifyId,
        transactionType: this.matchUpInfo.transactionType,
        typeId: this.matchUpInfo.typeId,
        promotion: 1
      };
      let res = await getMatchUpListPage(pramas);
      if (res.data.code == 0) {
        this.setReleaseData = res.data.data.records;
        this.total = res.data.data.total;
        this.setReleaseData.forEach(item => {
          if (item.img != null && item.img != "") {
            let imgList = item.img.split(",");
            for (let i = 0; i < imgList.length; i++) {
              if (imgList[i].indexOf("http") == -1) {
                imgList[i] = this.imgURL + imgList[i];
              }
            }
            item.img = imgList[0];
            this.imgUrlRelease = imgList[0];
          } else {
            this.imgUrlRelease = item.img;
          }
        });
        this.total = res.data.data.total;
      }
    },

    // 撮合信息关键字搜索
    handlematchUpQuery() {
      this.currentPage = 1;
      this.getMatchUpListPage();
    },

    // 打开撮合信息发布
    handleSetRelease() {
      this.setReleaseDialog = true;
      this.matchUpFileList = [];
      this.matchUpTitle = "信息发布";

      this.$nextTick(() => {
        this.$refs["matchForm"].resetFields();
      });
    },
    // 关闭撮合信息发布
    handleSetReleaseClose() {
      this.setReleaseDialog = false;
      this.matchUpForm = {
        transactionTitle: "", // 标题
        matchUpType: "", // 产品类型
        transactionType: "", // 交易类型
        address: "", // 详细地址
        transactionNumber: "", // 数量
        contacts: "", // 发布人
        numberUnit: "", // 数量单位
        contactsPhone: "", // 联系电话
        transactionPrice: "", // 价格
        priceUnit: "", //价格单位
        transactionDate: "", // 日期
        img: [], // 图片
        pronince: "",
        city: "",
        county: ""
      };
    },

    // 发布撮合信息
    async submitMatchUpRelease(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (JSON.parse(this.$store.state.isLogin)) {
            if (this.matchUpForm.img.length == 0) {
              return this.$message({
                message: "请选择图片",
                type: "warning"
              });
            } else if (this.matchUpForm.img.length > 1) {
              this.matchUpForm.img = this.matchUpForm.img.join(",");
            } else if (this.matchUpForm.img.length == 1) {
              this.matchUpForm.img = this.matchUpForm.img[0];
            }
            let res = await addMatchUp(this.matchUpForm);
            if (res.data.code == 0) {
              this.setReleaseDialog = false;
              this.matchUpForm = {
                transactionTitle: "", // 标题
                matchUpType: "", // 产品类型
                transactionType: "", // 交易类型
                address: "", // 详细地址
                transactionNumber: "", // 数量
                contacts: "", // 发布人
                numberUnit: "", // 数量单位
                contactsPhone: "", // 联系电话
                transactionPrice: "", // 价格
                priceUnit: "", //价格单位
                transactionDate: "", // 日期
                img: [], // 图片
                pronince: "",
                city: "",
                county: ""
              };
              this.getMatchUpListPage();
            }
          } else {
            return this.$message({
              type: "warning",
              message: "请先登录!"
            });
          }
        } else {
          return false;
        }
      });
    },

    // 撮合信息分页
    matchUpCurrentChange(value) {
      this.currentPage = value;
      this.getMatchUpListPage();
    },
    uploadExceed() {
      this.$message.error("一次只能上传6个文件！");
    },
    // 上传 交易产品图片
    handleMatchUpUpload(file) {
      this.matchUpReleaseUploadImg(file.raw);
    },
    // 上传源文件
    async matchUpReleaseUploadImg(file) {
      if (JSON.parse(this.$store.state.isLogin)) {
        let fd = new FormData();
        fd.append("file", file); //传文件
        const res = await matchUpReleaseUploadImg(fd);
        this.matchUpForm.img.push(this.imgURL + "/" + res.data);
        // this.matchUpForm.img = res.data;
      } else {
        return this.$message({
          type: "warning",
          message: "请先登录!"
        });
      }
    }
  }
};
</script>
<style lang="scss">
@import "../utils/css/common.scss";
@import "../utils/css/dealmakers.scss";
</style>
